/**
 * @author 冷 (https://github.com/LengYXin)
 * @email lengyingxin8966@gmail.com
 * @create date 2021-09-02 16:49:07
 * @modify date 2021-09-02 16:49:07
 * @desc 三方订单
 */
import lodash from 'lodash';
import { BindAll } from 'lodash-decorators';
import { computed } from 'mobx';
import { EnumAPI } from '../../apis';
import { AjaxBasics } from '../../helpers';
import { BaseModel, BasesController } from '../bases';

@BindAll()
export class ThirdOrdersController<T = any> extends BasesController<T> {
  PaginationParams: any;
  constructor() {
    super();
    this.reset({
      dataKey: 'id',
      infinite: false,
      details: EnumAPI.third_orders_details, // 根据状态调用的接口不同
      pagination: EnumAPI.third_orders_list,
      insert: EnumAPI.orders_create,
      paginationParams: {
        currentKey: 'pageNo',
        pageSizeKey: 'pageSize',
        filterKey: 'search',
        response: { valueGetter: this.paginationValueGetter },
      },
    });
  }
  /**
   * 加载详情数据
   * @param body
   * @param AjaxConfig
   * @returns entity
   */
  // async onFind(body?: string | number | { [key: string]: any }) {
  //   return this.Details.onLoad(
  //     body
  //   );
  // }

  Model = new BaseModel({ type: 'object', storageKey: 'order_status' });

  /**
   * 订单全部状态
   */
  @computed
  get OrderStatus(): Array<any> {
    // return this.Model.get('OrderStatus', [])
    return [
      { label: '正向订单', name: '正向订单', value: '0' },
      { label: '退货订单', name: '退货订单', value: '1' },
    ];

    return lodash.get(this.Model.value, 'OrderStatus', []);
  }

  /**
   * 物流信息
   */
  @computed
  get logisticsList(): Array<any> {
    return lodash.get(this.Model.value, 'logisticsList', []);
  }

  /**
   * 转换列表数据
   * @param response
   * @returns
   */
  paginationValueGetter(response) {
    let list = lodash.get(response, 'list', []);
    // // // 重组数据
    const dataSource = lodash.map(list, (val, key) => {
      // 按钮控制
      // const actionList = lodash.map(
      //   lodash.filter(lodash.get(val, `[0].actionList`), [
      //     'operationValue',
      //     '1',
      //   ]),
      //   (ord) =>
      //     // 转换按钮
      //     lodash.assign({}, ord, {
      //       operationRemark: lodash.head(
      //         lodash.split(ord.operationRemark, '按钮'),
      //       ),
      //     }),
      // );
      const actionList = [
        {
          operationKey: 'logisticsButton',
          operationRemark: '物流信息',
          operationValue: val.status == '已发货',
        },
        {
          operationKey: 'viewInfoButton',
          operationRemark: '查看详情',
          operationValue: 1,
        },
      ];
      return {
        ...val,
        actionList,
      };
    });

    return {
      total: lodash.get(response, 'count'),
      dataSource,
    };
  }

  /**
   * @ 订单的状态
   */
  async getOrderStatus() {
    // 50010
    try {
      // if (this.OrderStatus.length) {
      //     return
      // }
      let res = await AjaxBasics.requestEnum(
        { ...EnumAPI.product_orderStatus, body: { id: '50010' } },
        { labelKey: 'name', valueKey: 'value' },
      );
      res = lodash.map(res, (item) => {
        lodash.set(
          item,
          '_statusIcon',
          lodash.get(
            {
              '1': 'quanbudingdan',
              '2': 'daishenhe',
              '3': 'a-bianzu19',
              '4': 'daiquerenshoukuan',
              '5': 'gerenzhongxin-daifahuo',
              '6': 'replay',
            },
            item.original.sort,
          ),
        );
        return item;
      });
      this.Model.merge({ OrderStatus: res });
    } catch (error) {}
  }

  /**
   * @ 取消订单
   */
  async orderCancel(body) {
    //
    return await AjaxBasics.request({ ...EnumAPI.order_cancel, body });
  }

  async submitPayInfo(body) {
    return await AjaxBasics.request({ ...EnumAPI.order_submitpayinfo, body });
  }

  /** 根据订单的id获取物流信息 */
  async getlogisticsList(orderId, pageNo, pageSize) {
    const res = await AjaxBasics.request<any>({
      ...EnumAPI.third_order_getstockinfo,
      body: {
        orderId,
        pageNo,
        pageSize,
      },
    });
    this.Model.merge({
      logisticsList: res.list,
    });
  }
  /** 根据订单的id获取支付信息 */
  async getPayInfo(orderNumber) {
    const res = await AjaxBasics.request<any>({
      ...EnumAPI.order_getpayinfo,
      body: { orderNumber },
    });
    return res;
    // this.Model.merge({ logisticsList: res.orderLogisticsInformationPackageList })
  }

  /** 根据订单的id获取支付信息 */
  async getCollectionInfo(code) {
    const res = await AjaxBasics.request<any>({
      ...EnumAPI.order_getcollectioninfo,
      body: { code },
    });
    return res;
  }

  clearLogisticsList() {
    this.Model.merge({ logisticsList: [] });
  }

  /** 根据订单的id获取物流信息 */
  async clearOrderFailed(orderNoList) {
    const res = await AjaxBasics.request<any>({
      ...EnumAPI.order_clearOrderFailed,
      body: { orderNoList },
    });
    return res;
  }
}
